export default "__VITE_PUBLIC_ASSET__25ca3c35__"